import styled from "styled-components";

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
`;

export const ProfileImage = styled.img`
    width: 100%;
`;